
import HttpService from "./http.service";
import FastApiService from "./fastapi.service";

export const setupAxiosInterceptors = (onUnauthenticated) => {
  const registerOn = (service) => {
    // Request: attach token unless explicitly skipped
    const onRequestSuccess = async (config) => {
      if (!config?.skipAuth) {
        const token = localStorage.getItem("token"); // adjust key if needed
        config.headers = config.headers || {};
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        } else {
          delete config.headers?.Authorization;
        }
      }
      // Ensure default content type if not set
      config.headers = { "Content-Type": "application/json", ...config.headers };
      return config;
    };

    const onRequestFail = (error) => Promise.reject(error);

    service.addRequestInterceptor(onRequestSuccess, onRequestFail);

    // Response: global 401/403 handler
    const onResponseSuccess = (response) => response;

    const onResponseFail = (error) => {
      const status =
        error?.response?.status ??
        error?.status ??
        error?.response?.data?.status;

      if (status === 401 || status === 403) {
        try {
          onUnauthenticated?.(); // e.g., clear token + redirect
        } catch (_) { }
      }
      return Promise.reject(error);
    };

    service.addResponseInterceptor(onResponseSuccess, onResponseFail);
  };

  // Register on both services
  registerOn(HttpService);
  registerOn(FastApiService);
};
